import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import { cn } from '@/lib/css-utils'
import { UserProfileType } from '@/lib/generated/graphql-types'
import { getUsernameInitials } from '@/lib/name'
import { CircleUser } from 'lucide-react'

interface UserAvatarProps {
  userAvatarUrl: string | null | undefined
  userProfile: UserProfileType | null | undefined
  isOnDark?: boolean
  size?: 'md' | 'lg'
}

const sizeMap = {
  md: {
    circleStyles: 'h-8 w-8',
    textStyles: 'text-md',
  },
  lg: {
    circleStyles: 'h-16 w-16',
    textStyles: 'text-2xl font-semibold leading-9',
  },
}

export function UserAvatar({
  userAvatarUrl,
  userProfile,
  isOnDark,
  size = 'md',
}: UserAvatarProps) {
  const firstName = userProfile?.firstName
  const fullName = [userProfile?.firstName, userProfile?.lastName]
    .filter(Boolean)
    .join(' ')
  const initials = getUsernameInitials(fullName)
  const { circleStyles, textStyles } = sizeMap[size] ?? sizeMap.md

  return (
    <Avatar className={circleStyles}>
      {userAvatarUrl ? (
        <AvatarImage src={userAvatarUrl} alt={firstName ?? ''} />
      ) : null}
      <AvatarFallback
        className={cn('text-white', textStyles, {
          'bg-blue-50': Boolean(initials),
          'text-topNav-unselected': !initials && !isOnDark,
          'text-topNav-link-textDark': !initials && isOnDark,
        })}
      >
        {initials ? (
          <span className="">{initials}</span>
        ) : (
          <CircleUser className={circleStyles} />
        )}
      </AvatarFallback>
    </Avatar>
  )
}
